
import { Player } from '../types/Game';
const GAME_PLAYERS_KEY = "players";

const saveGamePlayers = (players: Array<Player>): void => {
    window.localStorage.setItem(GAME_PLAYERS_KEY, JSON.stringify(players));
}

const getGamePlayers = (): Array<Player> | null => {
    const content = window.localStorage.getItem(GAME_PLAYERS_KEY);
    const players = content ? JSON.parse(content) : null;
    return players;
}


export default {
    saveGamePlayers,
    getGamePlayers
}